if (!customElements.get('image-zoom-modal')) {
  class ZoomModal extends HTMLElement {
    constructor() {
      super();
      this.selector = this.dataset.imageWrapperSelector;
      this.isOpen = false;
    }

    connectedCallback() {
      if (this.closest('main')) document.body.insertBefore(this, document.body.firstChild);

      window.addEventListener('click', (e) => {
        if (e.target.closest('[data-action')) return;
        const clickedElement = e.target.closest(this.selector) || e.target.closest('[data-zoom-action]');
        if(!clickedElement) return;

        if(!this.isOpen && e.target.closest(this.selector)) {
          this.triggerImage = e.target.closest('[data-zoom-slide]');
          if (!this.triggerImage) return;
          this.slides = [...e.target.closest(this.selector).querySelectorAll('[data-zoom-slide]')];          
          this.open();
          return;
        }

        const {
          zoomAction: action,
        } = clickedElement.dataset;

        switch (action) {
          case 'close':
          this.close();
          break;
          default: break;
        }

      })
    }

    close() {
      const fadeOut = function() {
        this.style.position = null;
        this.style.display = null;
        this.removeEventListener('transitionend', fadeOut);
      }

      this.addEventListener('transitionend', fadeOut, false);

      this.isOpen = false;
      this.innerHTML = '';
      document.body.classList.remove('overlay');

      this.style.opacity = null;
    }

    open() {
      const startingIndex = this.slides.findIndex(x => x === this.triggerImage);
      this.isOpen = true;
      document.body.classList.add('overlay');
      this.innerHTML = `
      <div class="relative w-full">
        <button data-zoom-action="close" type="button" aria-label="close modal" class="absolute bg-primaryLight block top-0 right-0 p-8 flex items-center transition duration-200 hover:text-accent1 z-10 animation-spin">
          <div class="w-3 h-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 12 12">
              <path d="M10.795 0 6 4.795 1.2 0 0 1.2 4.795 6 0 10.795 1.2 12 6 7.205 10.795 12 12 10.795 7.205 6 12 1.2z"/>
            </svg>
          </div>
        </button>
        <swiper-image-gallery data-starting-index="${startingIndex || 0}" class="flex">
          <div class="w-1/4 p-10 h-screen overflow-hidden hidden md:block">
            <div data-thumbs class="h-4/5">
              <div class="swiper-wrapper flex flex-col flex-wrap items-center justify-start gap-1.5 w-[max-content!important] text-transparent">
                ${this.slides.map((slide) => {
                  let img = slide;

                  if (slide.matches('video')) img = slide.querySelector('img');

                  return `
                    <div class="swiper-slide w-[72px!important]  h-[72px!important] cursor-pointer">
                      <img class="transition duration-200 border border-current block w-full h-full object-center object-cover" loading="lazy" height="78" width="72" alt="${img.alt}" src="${img.src.replaceAll('width=1242', 'width=200').replaceAll('height=1674', 'height=200')}" />
                      ${slide.matches('video') ? 
                        `
                          <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6">
                              <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M20.2836 10.5082C22.056 11.6966 22.056 14.3034 20.2836 15.4918L5.42066 25.4569C3.42753 26.7933 0.750001 25.3648 0.750001 22.9651L0.750002 3.03485C0.750002 0.635186 3.42753 -0.793253 5.42066 0.543085L20.2836 10.5082Z" fill="white"/>
                            </svg>
                          </span>
                        ` : 
                        ``
                      }
                    </div>
                  `;
                }).join('')}
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 h-screen flex justify-center items-center">
            <div data-gallery class="h-screen bg-image-bg aspect-[3/4] overflow-hidden">
              <div class="swiper-wrapper cursor-zoom-in">
                ${this.slides.map((slide) => {
                  return `
                  <div class="swiper-slide">
                    <div data-zoom-container class="swiper-zoom-container">
                      ${slide.matches('video') ? 
                        `
                          <video-player 
                            class="
                              block
                              relative 
                              [&[data-unmuted]_[data-action='unmute']]:hidden
                              [&[data-unmuted]_[data-action='mute']]:block
                              [&_[data-action='unmute']]:block
                              [&_[data-action='mute']]:hidden
                              mix-blend-multiply 
                              rounded-lg 
                              object-cover 
                              object-top 
                              w-full 
                              h-full
                            "
                          >
                            <video playsinline="playsinline" autoplay="autoplay" background="true" loop="loop" sizes="75vw" loading="lazy" class="mix-blend-multiply object-cover object-top rounded-lg w-full h-full md:aspect-[9/10]" muted="muted" preload="metadata" aria-label="${slide.getAttribute('aria-label')}" poster="${slide.getAttribute('poster')}">
                              <source src="${slide.querySelector('source').src}" type="video/mp4">
                              <img src="${slide.querySelector('img').src}" alt="${slide.querySelector('img').alt}"/>
                            </video>
                            <button 
                              class="w-8 h-8 absolute top-4 right-4" 
                              data-action="mute"
                            > 
                              <svg viewBox="0 0 16 16" height="100%" width="100%" focusable="false" role="img" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="StyledIconBase-sc-ea9ulj-0 hRnJPC"><title>Unmute icon</title><path fill-rule="evenodd" d="M7.563 2.069A.75.75 0 0 1 8 2.75v10.5a.75.75 0 0 1-1.238.57L3.472 11H1.75A1.75 1.75 0 0 1 0 9.25v-2.5C0 5.784.784 5 1.75 5h1.723l3.289-2.82a.75.75 0 0 1 .801-.111zM6.5 4.38 4.238 6.319a.75.75 0 0 1-.488.181h-2a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .488.18L6.5 11.62V4.38zm6.096-2.038a.75.75 0 0 1 1.06 0 8 8 0 0 1 0 11.314.75.75 0 0 1-1.06-1.06 6.5 6.5 0 0 0 0-9.193.75.75 0 0 1 0-1.06v-.001zm-1.06 2.121a.75.75 0 1 0-1.061 1.061 3.5 3.5 0 0 1 0 4.95.75.75 0 1 0 1.06 1.06 5 5 0 0 0 0-7.07l.001-.001z"></path></svg>
                            </button>
                            <button 
                              class="w-8 h-8 absolute top-4 right-4" 
                              data-action="unmute"
                            >
                              <svg viewBox="0 0 16 16" height="100%" width="100%" focusable="false" role="img" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="StyledIconBase-sc-ea9ulj-0 hRnJPC"><title>Mute icon</title><path fill-rule="evenodd" d="M8 2.75a.75.75 0 0 0-1.238-.57L3.472 5H1.75A1.75 1.75 0 0 0 0 6.75v2.5C0 10.216.784 11 1.75 11h1.723l3.289 2.82A.75.75 0 0 0 8 13.25V2.75zM4.238 6.32 6.5 4.38v7.24L4.238 9.68a.75.75 0 0 0-.488-.18h-2a.25.25 0 0 1-.25-.25v-2.5a.25.25 0 0 1 .25-.25h2a.75.75 0 0 0 .488-.18zm7.042-1.1a.75.75 0 1 0-1.06 1.06L11.94 8l-1.72 1.72a.75.75 0 1 0 1.06 1.06L13 9.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L14.06 8l1.72-1.72a.75.75 0 0 0-1.06-1.06L13 6.94l-1.72-1.72z"></path></svg>
                            </button>
                          </video-player>
                        ` : 
                        `<img class="block w-full h-full object-center object-contain" loading="lazy" height="2400" width="2400" alt="${slide.alt}" src="${slide.src.replaceAll('width=1200', 'width=2400').replaceAll('900x', '1800x')}" />`
                      }
                    </div>
                  </div>
                `}).join('')}
              </div>
            </div>
          </div>

          ${this.slides.length > 1 ? `
            <div class="flex items-center w-max gap-8 left-1/2 transform -translate-x-1/2 absolute bottom-0 bg-primaryLight z-20 px-5 py-8">
              <button class="disabled:opacity-20 hover:enabled:text-accent1" aria-label="previous slide" data-prev>
                <span class="block w-4 h-3 transform rotate-180">
                  <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                    <defs>
                      <clipPath id="dpuo5a2tba">
                      <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                      </clipPath>
                    </defs>
                    <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                  </svg>
                </span>
              </button>
              <div data-pagination></div>
              <button class="disabled:opacity-20 hover:enabled:text-accent1" aria-label="next slide" data-next>
                <span class="block w-4 h-3">
                  <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                    <defs>
                      <clipPath id="dpuo5a2tba">
                        <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                      </clipPath>
                    </defs>
                    <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                  </svg>
                </span>
              </button>
            </div>
          ` : ''}
        </swiper-image-gallery>
      </div>
      `;
      this.style.display = 'block';
      this.style.position = 'fixed';
      setTimeout(() => { this.style.opacity = 1 }, 10);
    }
  }

  customElements.define('image-zoom-modal', ZoomModal);
}